import React, { useState, useEffect } from 'react';
import { AiFillEye } from 'react-icons/ai';
import { motion } from 'framer-motion';

import { AppWrap, MotionWrap } from '../../wrapper';

import './Work.scss';


import { images } from '../../constants';

const Data = [
  {
    title: 'Octris',
    tags: 'Branding',
    description: 'Branding and Website designing for a startup company. Comming soon...',
    imgUrl: `${images.octris}`,
    projectLink: 'https://soon-comm.netlify.app/'
  },
  {
    title: 'Hair Salon Website',
    tags: 'Website',
    description: 'Multiple Responsive Website for Hair Salon Tina.',
    imgUrl: `${images.hairSalonTina}`,
    projectLink: 'https://www.frizerskisalontina.hr/'
  },
  {
    title: 'UI/UX',
    tags: 'UI/UX',
    description: 'A modern UI/UX Application for Dog Breed Checking.',
    imgUrl: `${images.dogCheck}`,
    projectLink: 'https://www.figma.com/proto/3g1EW40Mu37cR3gn1sPu9Q/DogCheck?page-id=2%3A49&node-id=15%3A211&viewport=193%2C372%2C0.17&scaling=scale-down&starting-point-node-id=15%3A172'
  },
  {
    title: 'Kindergarten Website',
    tags: 'Website',
    description: 'Responsive Website for Kindergarten Rozica.',
    imgUrl: `${images.kinderGarten}`,
    projectLink: 'https://djecji-vrtic-rozica.netlify.app/'
  },
  {
    title: ' Logo and Business Card',
    tags: 'Graphic',
    description: 'Sports Club Druzilovec Design: Logo and Visit Card.',
    imgUrl: `${images.sportClubSud}`,
    projectLink: 'https://drive.google.com/drive/folders/1dB1kTDd7JnETyFltiVfsu3zRtxLvsbUA'
  },
  {
    title: 'Landing Page Design',
    tags: 'UI/UX',
    description: 'DogCheck Website Design for App promotion.',
    imgUrl: `${images.dogCheckWeb}`,
    projectLink: 'https://www.figma.com/proto/3g1EW40Mu37cR3gn1sPu9Q/DogCheck?page-id=0%3A1&node-id=1%3A48&viewport=641%2C-227%2C0.23&scaling=min-zoom'
  },
  {
    title: 'Magazine: Zbirka',
    tags: 'Graphic',
    description: 'A magazine design with photographs taken by me.',
    imgUrl: `${images.magazine}`,
    projectLink: 'https://drive.google.com/file/d/1Kz1yyWvnSuhzWdSq2uLv40rSxI8Bs4BT/view?usp=sharing'
  }
];

const Work = () => {

  const [activeFilter, setActiveFilter] = useState('All');

  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });

  return (
    <div className='app__works'>
      <h2 className="head-text">My Creative <span>Portfolio</span> Section</h2>

      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className='app__work-portfolio'
      >
        {Data.map((work, index) => (
          <div className='app__work-item app__flex' key={index}>
            <div className='app__work-img app__flex'>
              <img src={(work.imgUrl)} alt={work.name} />

              <motion.div
                whileHover={{opacity: [0, 1]}}
                transition={{ duration: 0.25,  ease:'easeInOut', staggerChildren: 0.5}}
                className='app__work-hover app__flex'
              >
                <a href={work.projectLink} target="_blank" rel="noreferr">
                  <motion.div
                  whileInView={{scale: [0, 1]}}
                    whileHover={{scale: [1, 0.9]}}
                    transition={{ duration: 0.25}}
                    className='app__flex'
                  >
                    <AiFillEye />
                  </motion.div>
                </a>
              </motion.div>

            </div>

            <div className='app__work-content app__flex'>
              <h4 className='bold-text'>{work.title}</h4>
              <p className='p-text' style={{ marginTop: 10 }}>{work.description}</p>

              <div className='app__work-tag app__flex'>
                <p className='p-text'>{work.tags}</p>
              </div>
            </div>

          </div>
        ))}
      </motion.div>

    </div>
  );
}


export default AppWrap(
  MotionWrap(Work, 'app__work'), 
  'work', 
  );